import { gql } from '@apollo/client';

export const EXCHANGE_RATES_FOR_YEAR = gql`
  query ExchangeRatesForYear($year: Int!) {
    exchangeRatesForYear(year: $year) {
      monthYear
      rate
    }
  }
`;

export const SAVE_EXCHANGE_RATE = gql`
  mutation SaveExchangeRate($monthYear: String!, $rate: Float!) {
    saveExchangeRate(monthYear: $monthYear, rate: $rate) {
      monthYear
      rate
    }
  }
`;
